<div class="betbuilder-card">
    <div class="betbuilder-market-title" *ngIf="marketTitle">{{ marketTitle }}</div>
    <div class="betbuilder-market-content">
        <ms-bet-builder-market-card-list [event]="event" [fixtureId]="fixtureId" [markets]="builderMarkets"></ms-bet-builder-market-card-list>
    </div>
</div>
